import { LinkRoute } from '@/components/common/Link'
import { StyledContent } from '@/components/common/StyledContent'
import { IconWithLabel } from '@/components/icons/IconWithLabel'

import styles from './ErrorBlock.module.scss'

export const ErrorBlock = () => (
  <section className={styles.container}>
    <h2 className={styles.heading}>
      <IconWithLabel iconBefore='ban'>Error</IconWithLabel>
    </h2>
    <StyledContent>
      <p>
        There was a problem while loading this section. Try refreshing the page. If the problem persists, you can submit
        a <LinkRoute href='/bug-report'>bug report</LinkRoute>.
      </p>
    </StyledContent>
  </section>
)
